import React, { useState, useEffect, memo } from "react";
import PropTypes from "prop-types";
import { usePrevious } from "../../utilities/hooks";
import localization from "../../data/config";
import { IE11 } from "../../constants";
import "./style.css";
import "./ie.css";
import "./bootstrap-override.css";

const { ofLabel } = localization;

/**
 * @name Checkbox
 * @function
 * @description Displays a checkbox
 * @returns {JSX}
 * @param {*} props
 */
function Checkbox(props) {
  const [checked, setChecked] = useState(props.checked);
  const [value, setValue] = useState(props.value);
  const prevChecked = usePrevious(props.checked);

  useEffect(() => {
    if (prevChecked !== props.checked) setChecked(props.checked);

    return () => {
      if (props.value !== value) {
        setValue(props.value);
        setChecked(props.checked);
      }
    };
  });

  /**
   *  @method useEffect
   *   @description Changes the check state of Show All parameters checkbox
   *   when any other parameters checkbox state is changes
   */
  useEffect(() => {
    if (props.allParamsLength != props.selectionsLength) {
      props.setShowAllChecked(false);
    }
    if (props.allParamsLength == props.selectionsLength) {
      props.setShowAllChecked(true);
    }
  }, [props.allParamsLength, props.selectionsLength]);

  /**
   * @name handleChange
   * @method
   * @description Controls the state of the checkbox
   */
  const handleChange = (e) => {
    setChecked(!checked);
    if (props.onClick) props.onClick(encodeURI(props.value), !checked);
    if (props.functionCall) {
      props.functionCall();
    }
  };

  /**
   * @name getCountText
   * @function
   * @description Generates the text for the count of checked parameters
   * @returns {string} Text displaying the count of checked parameters and total parameters
   */
  const getCountText = () => {
    const totalParametersCount = props.parameters.length;
    const checkedParametersCount = props.parameters.reduce(
      (count, param) =>
        props.selections.includes(param.id) ? count + 1 : count,
      0
    );
    return `${checkedParametersCount} ${ofLabel} ${totalParametersCount}`;
  };

  /**
 * Handles the click event on a label element.
 * function to handle the click on the label of checkbox
 * @param {Event} e - The click event object.
 * @returns {void}
 */
  const handleLabelClick = (e) => {
    e.stopPropagation();
    handleChange();
  }
  let classes = ["checkboxParams"];

  if (IE11) classes.push("ie11");

  if (props.className) classes.push(props.className);

  return (
    <li
      className={`${
        !props.isClassificationTitle &&
        !props.isShowAllParamaeters &&
        "category__checkbox"
      } ${classes.join(" ")}`}
    >
      <input
        id={props.id}
        type="checkbox"
        value={props.value}
        checked={checked}
        onChange={handleChange}
        disabled={props.disabled}
        className="checkbox__input checkbox-global__input"
        aria-label={props.title}
      />
      <label
        onClick={handleLabelClick}
        dangerouslySetInnerHTML={{ __html: props.label }}
        title={props.title}
        className={
          props.isClassificationTitle ? "classification__label" : "params__text"
        }
      />
      {props.isClassificationTitle && (
        <p className="paramsCount">{getCountText()}</p>
      )}
    </li>
  );
}

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  value: "",
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  title: PropTypes.string,
  isClassificationTitle: PropTypes.bool,
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ),
  selections: PropTypes.arrayOf(PropTypes.string),
  functionCall: PropTypes.func,
  selectAllChangeIndividual: PropTypes.func,
  showAllChecked: PropTypes.bool,
  setShowAllChecked: PropTypes.func,
  selectionsLength: PropTypes.number,
  allParamsLength: PropTypes.number,
};

export default memo(Checkbox);

